import styled from "styled-components";

export const StyledPopper = styled("div")`
  &[data-popper-reference-hidden] {
    display: none !important;
    pointer-events: none !important;
  }
`;
